import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class AccountDataSourceService {
  public accountSubject = new BehaviorSubject<any>([]);
  public accountCountSubject = new BehaviorSubject<number>(0);
  analyticsSubject = new BehaviorSubject<any>([]);
  analytics = this.analyticsSubject.asObservable();
  cast = this.accountCountSubject.asObservable();
  public loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public accountShowToolBar = new BehaviorSubject<boolean>(false);
  toolbar = this.accountShowToolBar.asObservable();

  constructor() { }

  setAccountData(data) {
    this.accountSubject.next(data);

  }
  setAccountCount(data) {
    this.accountCountSubject.next(data);
  }
  setAccountToolBarVal(value) {
    this.accountShowToolBar.next(value);
  }

  setAnalyticsInfo(analyticsInfo) {
    this.analyticsSubject.next(analyticsInfo);
  }
  
}
